import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";

export const ComponentSelect = ({ options, value, onChange, testid, hideLevels, triggerRef }) => {
  const [open, setOpen] = useState(false);
  const selected = options.find((o) => o.value === value);
  const visibleOptions = hideLevels && hideLevels.length > 0 ? options.filter((o) => !hideLevels.includes(o.level)) : options;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          ref={triggerRef}
          data-testid={testid}
          type="button"
          className="flex w-full items-center justify-between gap-2 rounded-sm border border-zinc-300 bg-white px-2.5 py-1.5 text-left text-[13px] transition-colors hover:bg-zinc-50"
        >
          <span className={selected ? "text-zinc-900" : "text-zinc-400"}>
            {selected ? selected.label : "Select item…"}
          </span>
          <ChevronsUpDown className="h-3.5 w-3.5 shrink-0 text-zinc-400" strokeWidth={1.5} />
        </button>
      </PopoverTrigger>
      <PopoverContent data-testid={`${testid}-popover`} className="w-[320px] max-w-[calc(100vw-2rem)] p-0 rounded-sm" align="start">
        <Command>
          <CommandInput placeholder="Search items…" data-testid={`${testid}-search`} />
          <CommandList>
            <CommandEmpty>No items found.</CommandEmpty>
            <CommandGroup>
              {visibleOptions.map((o) => (
                <CommandItem
                  key={o.value}
                  value={o.label}
                  data-testid={`${testid}-option-${o.value}`}
                  onSelect={() => { onChange(o.value); setOpen(false); }}
                >
                  <Check className={`mr-2 h-3.5 w-3.5 ${value === o.value ? "opacity-100" : "opacity-0"}`} />
                  <span className="flex-1 text-[13px]">{o.label}</span>
                  <span className="ml-2 rounded-sm bg-zinc-100 px-1.5 py-0.5 text-[10px] font-medium text-zinc-500">{o.level}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export default ComponentSelect;
